import type { OffersEligibilityLocale } from "@/locales/fr/offers-eligibility";

const offersEligibilityLocale: OffersEligibilityLocale = {
  offersEligibility: {
    title: "Member offers",
    offers: "Offer concerned",
    conditionList: "List of conditions for the offer : {condition}",
    condition: "Conditions",
    conditionStatus: "Eligibility Adherent",
  },
};

export default offersEligibilityLocale;
